/*
  4U native wishlist
  Saved on the shopper's device (localStorage). No app, no account, no network calls
  except fetching product JSON on the wishlist page.
  Item shape: { h: handle, v: variant id, c: colour name, r: rating score, n: rating count, t: saved time }
  Wishlist page: each saved item has the site's two-tap Quick Add, plus an Add all to cart button.
*/
(function () {
  'use strict';
  if (window.FuWishlist) return;

  var KEY = 'fu-wishlist-v1';
  var MAX = 100;
  var EVT = 'fu:wishlist';
  var HEART_PATH = 'M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z';
  var HEART = '<svg class="fu-wl-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + HEART_PATH + '"/></svg>';
  var CROSS = '<svg class="fu-wl-x" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg>';
  var LABEL_ADD = 'Add to wishlist';
  var LABEL_REMOVE = 'Remove from wishlist';

  /* ---------- storage ---------- */
  var cache = null;

  function read() {
    if (cache) return cache;
    var list = [];
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      if (Array.isArray(parsed)) {
        list = parsed.filter(function (i) { return i && typeof i.h === 'string' && i.h; });
      }
    } catch (e) { list = []; }
    cache = list;
    return list;
  }

  function write(list) {
    cache = list.slice(0, MAX);
    try { window.localStorage.setItem(KEY, JSON.stringify(cache)); } catch (e) { /* storage full or blocked */ }
    emit();
  }

  function norm(s) { return String(s || '').trim().toLowerCase(); }

  function keyOf(item) {
    return item.h + '|' + (item.c ? norm(item.c) : 'v' + (item.v || ''));
  }

  function find(item) {
    var k = keyOf(item);
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (keyOf(list[i]) === k) return i;
    }
    return -1;
  }

  function has(item) { return !!item && find(item) > -1; }

  function add(item) {
    if (has(item)) return;
    var list = read().slice();
    item.t = Date.now();
    list.unshift(item);
    write(list);
  }

  function remove(item) {
    var idx = find(item);
    if (idx < 0) return;
    var list = read().slice();
    list.splice(idx, 1);
    write(list);
  }

  function toggle(item) {
    if (has(item)) { remove(item); return false; }
    add(item); return true;
  }

  function emit() {
    scheduleSync();
    try { document.dispatchEvent(new CustomEvent(EVT, { detail: { count: read().length } })); } catch (e) { /* old browsers */ }
  }

  /* ---------- helpers ---------- */
  function parseProductUrl(href) {
    if (!href) return null;
    var url;
    try { url = new URL(href, document.baseURI); } catch (e) { return null; }
    var m = url.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return null;
    return { h: decodeURIComponent(m[1]), v: url.searchParams.get('variant') || '' };
  }

  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function setPressed(btn, on) {
    var val = on ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== val) {
      btn.setAttribute('aria-pressed', val);
      btn.setAttribute('aria-label', on ? LABEL_REMOVE : LABEL_ADD);
    }
  }

  function pop(btn) {
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    btn.classList.add('is-pop');
  }

  function makeButton(extra) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fu-wl-btn' + (extra ? ' ' + extra : '');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', LABEL_ADD);
    btn.innerHTML = HEART;
    btn.addEventListener('animationend', function () { btn.classList.remove('is-pop'); });
    return btn;
  }

  /* ---------- product cards ---------- */
  function cardLink(card) {
    return card.querySelector('a.product-card__image-link[href*="/products/"]') ||
      card.querySelector('a.product-card__title[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');
  }

  function cardItem(card) {
    var p = parseProductUrl(cardLink(card) && cardLink(card).getAttribute('href'));
    if (!p) return null;
    var item = { h: p.h, v: p.v, c: text(card.querySelector('.product-card__variant-colour')) };
    var score = text(card.querySelector('.product-card__rating-score'));
    var count = text(card.querySelector('.product-card__rating-count')).replace(/[^\d]/g, '');
    if (score) item.r = score;
    if (count) item.n = count;
    return item;
  }

  function decorateCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = [];
    if (scope.matches && scope.matches('.product-card')) cards.push(scope);
    Array.prototype.push.apply(cards, scope.querySelectorAll('.product-card'));
    cards.forEach(function (card) {
      if (card.__fuWl || card.closest('[data-fu-wl-skip]')) return;
      var media = card.querySelector('.product-card__media');
      if (!media || !cardLink(card)) return;
      card.__fuWl = true;
      card.classList.add('fu-wl-card');
      var btn = makeButton('fu-wl-btn--card');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = cardItem(card);
        if (!item) return;
        var on = toggle(item);
        setPressed(btn, on);
        if (on) pop(btn);
      });
      media.appendChild(btn);
      card.__fuWlBtn = btn;
      card.addEventListener('mouseenter', function () {
        var qa = media.querySelector('.fu-qa');
        btn.style.setProperty('--fu-wl-lift', qa ? qa.offsetHeight + 'px' : '0px');
      });
      setPressed(btn, has(cardItem(card)));
    });
  }

  /* ---------- product page ---------- */
  var pdp = null;

  function pdpHandle() {
    var canon = document.querySelector('link[rel="canonical"]');
    var p = parseProductUrl(canon && canon.getAttribute('href'));
    if (!p) {
      var og = document.querySelector('meta[property="og:url"]');
      p = parseProductUrl(og && og.getAttribute('content'));
    }
    if (!p) p = parseProductUrl(window.location.href);
    return p ? p.h : '';
  }

  function pdpItem() {
    if (!pdp) return null;
    var info = pdp.info;
    var idInput = info.querySelector('form.product-form [name="id"]') ||
      document.querySelector('form.product-form [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    var colour = '';
    var radios = info.querySelectorAll('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      if (/^colou?r$/i.test(radios[i].name || '') || /colou?r/i.test(radios[i].name || '')) { colour = radios[i].value; break; }
    }
    if (!colour) {
      var sel = info.querySelector('variant-selects select[name*="olor"], variant-selects select[name*="olour"]');
      if (sel) colour = sel.value;
    }
    var item = { h: pdp.handle, v: idInput ? String(idInput.value || '') : '', c: colour };
    var score = text(info.querySelector('.product-card__rating-score, [data-fu-rating-score]'));
    if (score) item.r = score;
    return item;
  }

  /* The heart sits in the top right corner of the main product gallery,
     on the container that wraps the slider so it stays put while swiping */
  function pdpGallery(info) {
    var scope = info.closest('.featured-product, .product') || document;
    var g = scope.querySelector('media-gallery') || document.querySelector('media-gallery');
    if (!g) return null;
    return g.querySelector('.product__media-container > .relative') || g.querySelector('.product__media-container') || g;
  }

  function placePdpButton() {
    if (!pdp) return;
    var gal = pdpGallery(pdp.info);
    if (gal) {
      if (window.getComputedStyle(gal).position === 'static') gal.style.position = 'relative';
      pdp.btn.classList.remove('fu-wl-btn--inline');
      gal.appendChild(pdp.btn);
    } else if (pdp.title) {
      pdp.btn.classList.add('fu-wl-btn--inline');
      pdp.title.classList.add('fu-wl-title');
      pdp.title.appendChild(pdp.btn);
    }
  }

  function setupPdp() {
    if (pdp) return;
    var title = document.querySelector('product-info .product__title');
    if (!title || title.closest('quick-view, .quick-view, [data-fu-wl-skip]')) return;
    var handle = pdpHandle();
    if (!handle) return;
    var info = title.closest('product-info');
    var btn = makeButton('fu-wl-btn--pdp');
    pdp = { info: info, btn: btn, handle: handle, title: title };
    placePdpButton();
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var item = pdpItem();
      if (!item) return;
      var on = toggle(item);
      setPressed(btn, on);
      if (on) pop(btn);
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('product-info')) {
        setTimeout(syncAll, 60);
      }
    });
  }

  /* ---------- header count ---------- */
  function syncCounts() {
    var n = read().length;
    var label = n ? 'Wishlist, ' + n + (n === 1 ? ' item' : ' items') : 'Wishlist';
    document.querySelectorAll('[data-fu-wl-count]').forEach(function (el) {
      var t = String(n);
      if (el.textContent !== t) el.textContent = t;
      if (n && el.hasAttribute('hidden')) el.removeAttribute('hidden');
      if (!n && !el.hasAttribute('hidden')) el.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-fu-wl-link]').forEach(function (a) {
      if (a.getAttribute('aria-label') !== label) a.setAttribute('aria-label', label);
    });
  }

  /* ---------- sync ---------- */
  function syncAll() {
    document.querySelectorAll('.fu-wl-card').forEach(function (card) {
      if (card.__fuWlBtn) setPressed(card.__fuWlBtn, has(cardItem(card)));
    });
    if (pdp) {
      if (!pdp.btn.isConnected) placePdpButton();
      setPressed(pdp.btn, has(pdpItem()));
    }
    syncCounts();
  }

  var syncQueued = false;
  function scheduleSync() {
    if (syncQueued) return;
    syncQueued = true;
    (window.requestAnimationFrame || setTimeout)(function () { syncQueued = false; syncAll(); });
  }

  var decorateQueued = false;
  function scheduleDecorate() {
    if (decorateQueued) return;
    decorateQueued = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      decorateQueued = false;
      decorateCards(document);
      syncAll();
    });
  }

  function observe() {
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function (records) {
      var needDecorate = false, needSync = false;
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes') {
          if (r.target.closest && r.target.closest('.fu-wl-card')) needSync = true;
          continue;
        }
        for (var j = 0; j < r.addedNodes.length; j++) {
          var node = r.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches('.product-card') || node.querySelector('.product-card')) { needDecorate = true; break; }
          if (node.closest && node.closest('.fu-wl-card')) needSync = true;
        }
        if (needDecorate) break;
      }
      if (pdp && !pdp.btn.isConnected) needSync = true;
      if (needDecorate) scheduleDecorate();
      else if (needSync) scheduleSync();
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }

  /* ---------- wishlist page ---------- */
  var productCache = {};
  var SS_PREFIX = 'fu-wl-p:';
  var SS_TTL = 10 * 60 * 1000;
  var netFetched = {};

  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    try {
      var raw = window.sessionStorage.getItem(SS_PREFIX + handle);
      if (raw) {
        var stored = JSON.parse(raw);
        if (stored && stored.at && Date.now() - stored.at < SS_TTL && stored.p) {
          productCache[handle] = Promise.resolve(stored.p);
          return productCache[handle];
        }
      }
    } catch (e) { /* ignore */ }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    netFetched[handle] = true;
    productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (res.status === 404) return { __gone: true };
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (p) {
        if (p && !p.__gone) {
          try { window.sessionStorage.setItem(SS_PREFIX + handle, JSON.stringify({ at: Date.now(), p: slim(p) })); } catch (e) { /* ignore */ }
          return slim(p);
        }
        return p;
      })
      .catch(function () { delete productCache[handle]; return null; });
    return productCache[handle];
  }

  function slim(p) {
    if (p.__slim) return p;
    return {
      __slim: true,
      handle: p.handle,
      title: p.title,
      available: p.available,
      featured_image: p.featured_image,
      options: (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }),
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id, available: v.available, price: v.price, compare_at_price: v.compare_at_price,
          option1: v.option1, option2: v.option2, option3: v.option3,
          image: v.featured_image ? v.featured_image.src : ''
        };
      })
    };
  }

  function money(cents) {
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    var str;
    try {
      str = new Intl.NumberFormat('en-AU', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
    } catch (e) {
      str = '$' + (cents / 100).toFixed(2);
    }
    return str + ' ' + code;
  }

  function sizedImage(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function colourIndex(p) {
    for (var i = 0; i < p.options.length; i++) {
      if (/colou?r/i.test(p.options[i])) return i;
    }
    return -1;
  }

  /* Use the saved variant when it still exists and matches the saved colour,
     otherwise fall back to the first available variant in that colour. */
  function pickVariant(p, item) {
    var ci = colourIndex(p);
    var opt = ci > -1 ? 'option' + (ci + 1) : '';
    var byId = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === String(item.v)) { byId = p.variants[i]; break; }
    }
    var colour = item.c || (byId && opt ? byId[opt] : '');
    if (byId && (!opt || !colour || norm(byId[opt]) === norm(colour))) {
      return { v: byId, colour: opt ? byId[opt] : '' };
    }
    var same = opt && colour ? p.variants.filter(function (v) { return norm(v[opt]) === norm(colour); }) : [];
    var pool = same.length ? same : p.variants;
    var chosen = pool.filter(function (v) { return v.available; })[0] || pool[0];
    return { v: chosen, colour: opt && chosen ? chosen[opt] : '' };
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* ---------- wishlist page: quick add + add all ----------
     Same two-tap Quick Add as the product cards: on touch screens the + on the photo slides up the
     size panel (assets/fu-quick-size.js), with a mouse the panel shows on hover (assets/fu-cards.js).
     Same .fu-qa markup, styles and add-to-cart flow (bundled cart drawer sections, cart:updated,
     pubsub cartUpdate), so the cart count, free shipping bar and upsells all update.
     Adding to cart never removes anything from the wishlist. */
  var QS_TOUCH = !!(window.matchMedia && (window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches));
  var QS_PLUS = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1.5v11M1.5 7h11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var LAST_SIZE = 'fu-last-size';
  var qsFresh = {};
  var qsCur = null;

  function shopRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  /* Product data for adding: reuse what this page view already fetched, otherwise fetch it fresh
     (never trust the 10 minute session copy for stock). One request per product, cached. */
  function qsProduct(h) {
    if (qsFresh[h]) return qsFresh[h];
    var cached = productCache[h];
    if (!netFetched[h]) {
      delete productCache[h];
      try { window.sessionStorage.removeItem(SS_PREFIX + h); } catch (e) { /* ignore */ }
    }
    qsFresh[h] = getProduct(h).then(function (p) {
      if (p && !p.__gone && p.variants) return p;
      delete qsFresh[h];
      return cached ? cached.then(function (c) { return c && c.variants ? c : null; }) : null;
    });
    return qsFresh[h];
  }

  /* The sizes of the saved colour */
  function qsInfo(p, item) {
    var ci = colourIndex(p);
    var colour = pickVariant(p, item).colour;
    var vs = p.variants;
    if (ci > -1 && colour) {
      var key = 'option' + (ci + 1);
      var same = p.variants.filter(function (v) { return norm(v[key]) === norm(colour); });
      if (same.length) vs = same;
    }
    return { ci: ci, colour: colour, vs: vs };
  }

  function qsLabeller(p, info, sheet) {
    var ci = info.ci, si = -1, others = [];
    p.options.forEach(function (o, i) {
      if (si < 0 && /size/i.test(o)) si = i;
      if (i !== ci) others.push(i);
    });
    var li = si > -1 ? si : (others.length === 1 ? others[0] : -1);
    return function (v) {
      if (info.vs.length === 1 && !sheet) return 'Add to cart';
      var l = li > -1 ? v['option' + (li + 1)] : others.map(function (i) { return v['option' + (i + 1)]; }).filter(Boolean).join(' / ');
      if (!l || l === 'Default Title') l = sheet ? 'One size' : ([v.option1, v.option2, v.option3].filter(Boolean).join(' / ') || 'Add to cart');
      return l;
    };
  }

  function lastSize() {
    try { return window.localStorage.getItem(LAST_SIZE) || ''; } catch (e) { return ''; }
  }
  function rememberSize(s) {
    s = String(s || '').replace(/\s+/g, ' ').trim();
    if (!s || s.length > 12 || /add to cart|one size|\.\.\.|✓/i.test(s)) return;
    try { window.localStorage.setItem(LAST_SIZE, s); } catch (e) { /* ignore */ }
  }

  /* ---- Add to cart: the theme's own flow, as in assets/fu-quick-size.js ---- */
  function qsBundled() {
    var s = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: s } })); } catch (e) { /* ignore */ }
    return s.filter(function (x, i) { return x && s.indexOf(x) === i; });
  }
  function qsSwap(sec) {
    if (!sec) return;
    Object.keys(sec).forEach(function (id) {
      if (!sec[id]) return;
      var doc = new DOMParser().parseFromString(sec[id], 'text/html');
      ['MiniCart-', 'MainCart-'].forEach(function (pre) {
        var a = document.getElementById(pre + id), b = doc.getElementById(pre + id);
        if (a && b) a.innerHTML = b.innerHTML;
      });
    });
  }
  function qsOpenDrawer() {
    var d = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (d && typeof d.show === 'function') { try { d.show(); return true; } catch (e) { /* fall through */ } }
    var b = document.querySelector('.cart-drawer-button[aria-controls="CartDrawer"]');
    if (b) { b.click(); return true; }
    return false;
  }
  function qsToCart() {
    if (!qsOpenDrawer()) window.location.href = shopRoot() + 'cart';
  }
  /* One request for one or many variants */
  function qsAdd(ids) {
    var body = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
    var sec = qsBundled();
    var path = window.location.pathname || '/';
    if (sec.length) { body.sections = sec; body.sections_url = path.charAt(0) === '/' ? path : '/'; }
    return fetch(shopRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || (typeof j.errors === 'string' ? j.errors : '') || ''); return j; }); })
      .then(function (j) {
        qsSwap(j.sections);
        return fetch(shopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('cart-count').forEach(function (c) { c.textContent = cart.item_count; if (cart.item_count > 0) c.removeAttribute('hidden'); else c.setAttribute('hidden', ''); });
          try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (x) { /* ignore */ }
          if (window.theme && theme.pubsub && theme.pubsub.publish && theme.pubsub.PUB_SUB_EVENTS) {
            try { theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'fu-wishlist', cart: Object.assign({}, cart, { sections: j.sections || {} }) }); } catch (x) { /* ignore */ }
          }
        });
      });
  }
  function qsErr(e) {
    var m = (e && e.message) || '';
    return m ? m.replace(/\s+/g, ' ').trim() : 'Could not add that size. Please try again.';
  }

  /* ---- Size panel (same markup as the card Quick Add) ---- */
  function qsPanel(p, item, touch) {
    var info = qsInfo(p, item);
    var vs = info.vs, ci = info.ci;
    var label = qsLabeller(p, info, false);
    var panel = document.createElement('div');
    panel.className = 'fu-qa' + (touch ? ' fu-qs' : '');
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', 'Quick Add');
    panel.innerHTML = '<p class="fu-qa-label">Quick Add</p><div class="fu-qa-sizes"></div><div class="fu-qa-msg" aria-live="polite"></div>';
    var wrap = panel.querySelector('.fu-qa-sizes');
    var msg = panel.querySelector('.fu-qa-msg');
    var wide = false;
    vs.forEach(function (v) {
      var l = label(v);
      if (vs.length > 1 && String(l).length > 4) wide = true;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fu-qa-size' + (vs.length === 1 ? ' is-one' : '');
      b.textContent = l;
      b.setAttribute('aria-label', 'Add ' + p.title + (ci > -1 && v['option' + (ci + 1)] ? ' ' + v['option' + (ci + 1)] : '') + (vs.length > 1 ? ' size ' + l : '') + ' to cart');
      if (!v.available) { b.disabled = true; b.title = 'Sold out'; }
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (b.disabled || panel.__busy) return;
        panel.__busy = true;
        msg.textContent = '';
        b.classList.add('is-busy');
        b.textContent = '...';
        qsAdd([v.id]).then(function () {
          b.classList.remove('is-busy');
          b.classList.add('is-done');
          b.textContent = '✓';
          setTimeout(function () {
            panel.__busy = false;
            if (qsCur && qsCur.panel === panel) qsClose();
            qsToCart();
            setTimeout(function () { b.classList.remove('is-done'); b.textContent = l; }, 300);
          }, 450);
        }).catch(function (x) {
          panel.__busy = false;
          b.classList.remove('is-busy');
          b.textContent = l;
          msg.textContent = qsErr(x);
        });
      });
      wrap.appendChild(b);
    });
    if (wide) panel.classList.add('fu-qs--wide');
    ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
      panel.addEventListener(evt, function (e) { e.stopPropagation(); if (evt === 'click') e.preventDefault(); }, evt === 'touchstart' ? { passive: true } : false);
    });
    return panel;
  }

  function qsClose(instant) {
    if (!qsCur) return;
    var c = qsCur; qsCur = null;
    c.btn.classList.remove('fu-qs-on');
    c.btn.style.transform = '';
    c.btn.setAttribute('aria-expanded', 'false');
    c.btn.setAttribute('aria-label', 'Quick add');
    c.card.classList.remove('fu-qs-open');
    c.panel.classList.remove('is-in');
    if (instant) { c.panel.remove(); return; }
    setTimeout(function () { c.panel.remove(); }, 220);
  }

  function qsShow(card, btn, panel, err) {
    if (qsCur) qsClose(true);
    if (err) panel.querySelector('.fu-qa-msg').textContent = err;
    btn.parentElement.insertBefore(panel, btn);
    qsCur = { card: card, btn: btn, panel: panel };
    /* Lift the + into the panel's label row (it turns into the x) */
    var lab = panel.querySelector('.fu-qa-label');
    var h = btn.offsetHeight || 34;
    var bottom = parseFloat(window.getComputedStyle(btn).bottom) || 8;
    var lift = bottom + h / 2 + lab.offsetTop + lab.offsetHeight / 2 - panel.offsetHeight;
    btn.style.transform = 'translateY(' + Math.min(0, Math.round(lift)) + 'px)';
    btn.classList.add('fu-qs-on');
    btn.setAttribute('aria-expanded', 'true');
    btn.setAttribute('aria-label', 'Close Quick Add');
    card.classList.add('fu-qs-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { panel.classList.add('is-in'); }); });
  }

  function qsOpen(card, btn, item) {
    if (qsCur && qsCur.card === card) { qsClose(); return; }
    qsClose();
    btn.classList.add('is-busy');
    qsProduct(item.h).then(function (p) {
      btn.classList.remove('is-busy');
      var link = card.querySelector('.fu-wlp__img-link');
      if (!p || !p.variants) { if (link) window.location.href = link.href; return; }
      var vs = qsInfo(p, item).vs;
      if (vs.length === 1 && vs[0].available) {
        btn.classList.add('is-busy');
        qsAdd([vs[0].id]).then(function () {
          btn.classList.remove('is-busy');
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
          qsToCart();
        }).catch(function (x) {
          btn.classList.remove('is-busy');
          qsShow(card, btn, qsPanel(p, item, true), qsErr(x));
        });
        return;
      }
      qsShow(card, btn, qsPanel(p, item, true), '');
    });
  }

  /* Mouse: build the hover panel the first time the card is hovered or focused */
  function qsHover(card, item) {
    if (card.__fuQaPrep) return;
    card.__fuQaPrep = true;
    qsProduct(item.h).then(function (p) {
      if (!p || !p.variants || !card.isConnected) { card.__fuQaPrep = false; return; }
      var media = card.querySelector('.fu-wlp__media');
      if (!media || media.querySelector('.fu-qa')) return;
      media.appendChild(qsPanel(p, item, false));
      card.classList.add('fu-qa-ready');
    });
  }

  function qsSetup(card, item, p, soldOut) {
    if (card.__fuQs || soldOut || /gift/i.test(p.handle)) return;
    var media = card.querySelector('.fu-wlp__media');
    if (!media) return;
    card.__fuQs = true;
    if (QS_TOUCH) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fu-qs-btn fu-wlp__qs';
      b.setAttribute('aria-label', 'Quick add');
      b.setAttribute('aria-expanded', 'false');
      b.innerHTML = QS_PLUS;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (b.classList.contains('is-busy')) return;
        qsOpen(card, b, item);
      });
      media.appendChild(b);
    } else {
      var prep = function () { qsHover(card, item); };
      card.addEventListener('pointerenter', prep);
      card.addEventListener('focusin', prep);
    }
  }

  var qsBound = false;
  function qsBind() {
    if (qsBound) return;
    qsBound = true;
    /* Close the tapped panel: the + again, a tap outside, or Escape */
    document.addEventListener('pointerdown', function (e) {
      if (!qsCur) return;
      if (qsCur.panel.contains(e.target) || qsCur.btn.contains(e.target)) return;
      qsClose();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qsCur) qsClose(); });
  }

  /* ---- Pick your sizes: bottom sheet on mobile, modal on desktop ---- */
  var sheet = null;

  function focusables(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null || n === document.activeElement; }
    );
  }

  function lockScroll(on) {
    var html = document.documentElement;
    if (on) {
      var gap = window.innerWidth - html.clientWidth;
      if (gap > 0) document.body.style.paddingRight = gap + 'px';
      html.classList.add('fu-wls-lock');
    } else {
      html.classList.remove('fu-wls-lock');
      document.body.style.paddingRight = '';
    }
  }

  function closeSheet(instant) {
    if (!sheet) return;
    var s = sheet; sheet = null;
    document.removeEventListener('keydown', s.onKey, true);
    s.root.classList.remove('is-in');
    lockScroll(false);
    if (s.trigger && s.trigger.isConnected) { try { s.trigger.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    if (instant) { s.root.remove(); return; }
    setTimeout(function () { s.root.remove(); }, 300);
  }

  function openSheet(rows, trigger) {
    closeSheet(true);
    qsClose(true);
    var last = norm(lastSize());
    var root = document.createElement('div');
    root.className = 'fu-wls';
    root.innerHTML =
      '<div class="fu-wls__backdrop" data-fu-wls-close></div>' +
      '<div class="fu-wls__panel" role="dialog" aria-modal="true" aria-labelledby="FuWlsTitle" tabindex="-1">' +
        '<div class="fu-wls__head"><h2 class="fu-wls__title" id="FuWlsTitle">Pick your sizes</h2>' +
        '<button type="button" class="fu-wls__close" data-fu-wls-close aria-label="Close">' + CROSS + '</button></div>' +
        '<div class="fu-wls__list" role="list"></div>' +
        '<div class="fu-wls__foot"><p class="fu-wls__hint" aria-live="polite"></p>' +
        '<button type="button" class="button button--primary fu-wls__add" is="hover-button"><span class="btn-fill" data-fill></span><span class="btn-text"></span></button>' +
        '<div class="fu-qa-msg fu-wls__msg" aria-live="polite"></div></div>' +
      '</div>';
    var panel = root.querySelector('.fu-wls__panel');
    var list = root.querySelector('.fu-wls__list');
    var hint = root.querySelector('.fu-wls__hint');
    var addBtn = root.querySelector('.fu-wls__add');
    var addText = addBtn.querySelector('.btn-text');
    var msg = root.querySelector('.fu-wls__msg');
    var busy = false;

    function active() { return rows.filter(function (r) { return !r.out; }); }
    function update() {
      var a = active();
      if (!a.length) { closeSheet(); return; }
      var set = a.filter(function (r) { return r.sel; }).length;
      var missing = a.length - set;
      if (!busy) addText.textContent = 'ADD ' + set + (set === 1 ? ' ITEM' : ' ITEMS') + ' TO CART';
      addBtn.disabled = busy || !set || missing > 0;
      hint.textContent = missing ? 'Pick a size for ' + missing + (missing === 1 ? ' more item' : ' more items') + ', or tap × to leave it out.' : '';
    }

    rows.forEach(function (r) {
      var info = r.info;
      var label = qsLabeller(r.p, info, true);
      var v0 = pickVariant(r.p, r.item).v;
      var img = (v0 && v0.image) || r.p.featured_image || '';
      var name = r.p.title + (info.colour ? ' ' + info.colour : '');
      var row = document.createElement('div');
      row.className = 'fu-wls__row';
      row.setAttribute('role', 'listitem');
      row.innerHTML =
        '<div class="fu-wls__thumb">' + (img ? '<img src="' + esc(sizedImage(img, 180)) + '" alt="" loading="lazy" decoding="async">' : '') + '</div>' +
        '<div class="fu-wls__info"><p class="fu-wls__name">' + esc(r.p.title) +
        (info.colour ? '<span class="fu-wls__colour">' + esc(info.colour) + '</span>' : '') + '</p>' +
        '<div class="fu-qa-sizes fu-wls__sizes" role="group" aria-label="' + esc('Size for ' + name) + '"></div></div>' +
        '<button type="button" class="fu-wls__skip" aria-label="' + esc('Leave out ' + name) + '">' + CROSS + '</button>';
      var wrap = row.querySelector('.fu-wls__sizes');
      /* One size: already picked. Otherwise the size they last added with Quick Add, if it's in stock here */
      r.sel = info.vs.length === 1 && info.vs[0].available ? info.vs[0] : null;
      if (!r.sel && last) {
        info.vs.forEach(function (v) { if (!r.sel && v.available && norm(label(v)) === last) r.sel = v; });
      }
      var btns = [];
      info.vs.forEach(function (v) {
        var l = label(v);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fu-qa-size' + (info.vs.length === 1 ? ' is-one' : '');
        b.textContent = l;
        b.setAttribute('aria-pressed', r.sel === v ? 'true' : 'false');
        if (r.sel === v) b.classList.add('is-selected');
        if (!v.available) { b.disabled = true; b.title = 'Sold out'; b.setAttribute('aria-label', l + ', sold out'); }
        b.addEventListener('click', function () {
          if (b.disabled || busy) return;
          r.sel = v;
          btns.forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-selected', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          msg.textContent = '';
          update();
        });
        btns.push(b);
        wrap.appendChild(b);
      });
      row.querySelector('.fu-wls__skip').addEventListener('click', function () {
        if (busy) return;
        r.out = true;
        row.classList.add('is-out');
        var next = row.nextElementSibling || row.previousElementSibling;
        var target = next && next.querySelector('.fu-wls__skip');
        update();
        if (!sheet) return;
        (target || (addBtn.disabled ? panel : addBtn)).focus({ preventScroll: true });
        setTimeout(function () { row.remove(); }, 200);
      });
      list.appendChild(row);
    });

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled || busy) return;
      var ids = active().filter(function (r) { return r.sel; }).map(function (r) { return r.sel.id; });
      if (!ids.length) return;
      busy = true;
      msg.textContent = '';
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      addText.textContent = 'ADDING...';
      qsAdd(ids).then(function () {
        addBtn.removeAttribute('aria-busy');
        addBtn.classList.add('is-done');
        addText.textContent = 'ADDED ✓';
        setTimeout(function () { closeSheet(); qsToCart(); }, 450);
      }).catch(function (x) {
        busy = false;
        addBtn.removeAttribute('aria-busy');
        msg.textContent = qsErr(x);
        update();
      });
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-fu-wls-close]') && !busy) closeSheet();
    });
    var onKey = function (e) {
      if (!sheet || sheet.root !== root) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (!busy) closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(panel);
      if (!f.length) { e.preventDefault(); panel.focus(); return; }
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel || !panel.contains(document.activeElement))) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && (document.activeElement === lastEl || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', onKey, true);
    sheet = { root: root, trigger: trigger, onKey: onKey };

    update();
    document.body.appendChild(root);
    lockScroll(true);
    panel.focus({ preventScroll: true });
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); }); });
  }

  function WishlistPage(el) {
    this.el = el;
    this.grid = el.querySelector('[data-fu-wl-grid]');
    this.empty = el.querySelector('[data-fu-wl-empty]');
    this.meta = el.querySelector('[data-fu-wl-meta]');
    this.cards = {};
    this.data = {};
    this.allWrap = el.querySelector('[data-fu-wl-all]');
    this.allBtn = el.querySelector('[data-fu-wl-all-btn]');
    this.allText = el.querySelector('[data-fu-wl-all-text]');
    this.allMsg = el.querySelector('[data-fu-wl-all-msg]');
    var self = this;
    if (this.allBtn) this.allBtn.addEventListener('click', function (e) { e.preventDefault(); self.addAll(); });
    qsBind();
    var ph = this.grid.querySelectorAll('[data-fu-wl-placeholder]');
    for (var i = 0; i < ph.length; i++) ph[i].remove();
    this.render();
    document.addEventListener(EVT, function () { self.render(); });
  }

  WishlistPage.prototype.updateMeta = function (n) {
    if (!this.meta) return;
    if (n) {
      this.meta.textContent = n + (n === 1 ? ' saved item' : ' saved items');
      this.meta.hidden = false;
    } else {
      this.meta.hidden = true;
    }
  };

  WishlistPage.prototype.render = function () {
    var self = this;
    var list = read();
    var keys = {};
    list.forEach(function (item) { keys[keyOf(item)] = true; });
    Object.keys(this.cards).forEach(function (k) {
      if (!keys[k]) {
        if (qsCur && qsCur.card === self.cards[k]) qsClose(true);
        self.cards[k].remove(); delete self.cards[k]; delete self.data[k];
      }
    });
    list.forEach(function (item, idx) {
      var k = keyOf(item);
      var card = self.cards[k];
      if (!card) {
        card = self.buildCard(item);
        self.cards[k] = card;
      }
      if (self.grid.children[idx] !== card) self.grid.insertBefore(card, self.grid.children[idx] || null);
    });
    this.grid.hidden = !list.length;
    if (this.empty) this.empty.hidden = !!list.length;
    this.updateMeta(list.length);
    this.updateAll();
  };

  /* Add all to cart: N = saved items still in stock in their colour; hidden below 2 */
  WishlistPage.prototype.updateAll = function () {
    if (!this.allWrap || !this.allText) return;
    var self = this, n = 0;
    read().forEach(function (item) {
      var d = self.data[keyOf(item)];
      if (d && !d.soldOut) n++;
    });
    if (!this.allBusy) this.allText.textContent = 'ADD ALL TO CART (' + n + ')';
    this.allWrap.hidden = n < 2 && !this.allBusy;
  };

  WishlistPage.prototype.setAllBusy = function (on, text) {
    this.allBusy = on;
    this.allBtn.disabled = on;
    if (on) this.allBtn.setAttribute('aria-busy', 'true'); else this.allBtn.removeAttribute('aria-busy');
    if (text) this.allText.textContent = text;
    if (!on) this.updateAll();
  };

  WishlistPage.prototype.addAll = function () {
    var self = this;
    if (this.allBusy) return;
    var items = read().filter(function (item) { var d = self.data[keyOf(item)]; return d && !d.soldOut; });
    if (!items.length) return;
    if (this.allMsg) this.allMsg.textContent = '';
    this.setAllBusy(true, 'LOADING SIZES...');
    Promise.all(items.map(function (item) {
      return qsProduct(item.h).then(function (p) { return { item: item, p: p || self.data[keyOf(item)].p }; });
    })).then(function (res) {
      var rows = [];
      res.forEach(function (r) {
        if (!r.p || !r.p.variants) return;
        var info = qsInfo(r.p, r.item);
        if (!info.vs.some(function (v) { return v.available; })) return;
        r.info = info;
        r.known = info.vs.length === 1 ? info.vs[0] : null;
        rows.push(r);
      });
      if (!rows.length) {
        self.setAllBusy(false);
        if (self.allMsg) self.allMsg.textContent = 'These items have just sold out.';
        return;
      }
      /* Every item has only one option to add: no sheet needed */
      if (rows.every(function (r) { return r.known; })) {
        self.allText.textContent = 'ADDING...';
        return qsAdd(rows.map(function (r) { return r.known.id; })).then(function () {
          self.allBtn.classList.add('is-done');
          self.allText.textContent = 'ADDED ✓';
          setTimeout(function () {
            qsToCart();
            self.allBtn.classList.remove('is-done');
            self.setAllBusy(false);
          }, 450);
        });
      }
      self.setAllBusy(false);
      openSheet(rows, self.allBtn);
    }).catch(function (x) {
      self.allBtn.classList.remove('is-done');
      self.setAllBusy(false);
      if (self.allMsg) self.allMsg.textContent = qsErr(x);
    });
  };

  WishlistPage.prototype.buildCard = function (item) {
    var self = this;
    var card = document.createElement('div');
    card.className = 'fu-wlp__card is-loading';
    card.innerHTML =
      '<div class="fu-wlp__media"><a class="fu-wlp__img-link" href="#" tabindex="-1" aria-hidden="true"></a></div>' +
      '<div class="fu-wlp__body"><span class="fu-wlp__line"></span><span class="fu-wlp__line fu-wlp__line--short"></span></div>';
    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'fu-wl-btn fu-wl-btn--remove';
    rm.setAttribute('aria-label', LABEL_REMOVE);
    rm.innerHTML = CROSS;
    rm.addEventListener('click', function (e) {
      e.preventDefault();
      card.classList.add('is-removing');
      setTimeout(function () { remove(item); }, 220);
    });
    card.querySelector('.fu-wlp__media').appendChild(rm);

    getProduct(item.h).then(function (p) {
      if (!card.isConnected && !self.cards[keyOf(item)]) return;
      if (p && p.__gone) {
        /* Product was deleted or unpublished: drop it quietly */
        remove(item);
        return;
      }
      if (!p) {
        card.classList.remove('is-loading');
        card.classList.add('is-error');
        card.querySelector('.fu-wlp__body').innerHTML = '<p class="fu-wlp__note">Couldn\'t load this item. Refresh to try again.</p>';
        return;
      }
      self.fill(card, item, p, rm);
    });
    return card;
  };

  WishlistPage.prototype.fill = function (card, item, p, rm) {
    var pick = pickVariant(p, item);
    var v = pick.v;
    if (!v) { remove(item); return; }
    var colour = pick.colour || item.c || '';
    var url = '/products/' + encodeURIComponent(p.handle) + '?variant=' + v.id;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root !== '/') url = root.replace(/\/$/, '') + url;
    var img = v.image || p.featured_image || '';
    var soldOut = !p.available || !p.variants.some(function (x) {
      var ci = colourIndex(p);
      return x.available && (!colour || ci < 0 || norm(x['option' + (ci + 1)]) === norm(colour));
    });
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    var alt = esc(p.title + (colour ? ' ' + colour : ''));

    var media = card.querySelector('.fu-wlp__media');
    var link = media.querySelector('.fu-wlp__img-link');
    link.href = url;
    link.innerHTML = img
      ? '<img src="' + esc(sizedImage(img, 540)) + '" srcset="' + esc(sizedImage(img, 360)) + ' 360w, ' + esc(sizedImage(img, 540)) + ' 540w, ' + esc(sizedImage(img, 720)) + ' 720w" sizes="(min-width: 1024px) 25vw, 50vw" alt="' + alt + '" loading="lazy" decoding="async">'
      : '';
    /* Same badge markup as the theme's product cards, so each theme's own sale colours apply */
    var badgeText = '', badgeType = '';
    if (soldOut) {
      badgeText = 'Sold out'; badgeType = 'soldout';
    } else if (onSale) {
      var off = Math.round((1 - v.price / v.compare_at_price) * 100);
      if (off > 0) {
        var isBf = !!document.querySelector('link[href*="fu-bf.css"], script[src*="fu-bf.js"]');
        badgeText = isBf ? off + '% OFF' : 'Save ' + off + '%';
        badgeType = 'onsale';
      }
    }
    if (badgeText) {
      var badges = document.createElement('div');
      badges.className = 'badges fu-wlp__badges z-2 absolute grid gap-3 pointer-events-none';
      badges.innerHTML = '<span class="badge badge--' + badgeType + ' flex items-center gap-1d5 font-medium leading-none rounded-full">' + esc(badgeText) + '</span>';
      media.appendChild(badges);
    }
    rm.setAttribute('aria-label', 'Remove ' + p.title + (colour ? ' ' + colour : '') + ' from wishlist');

    var rating = '';
    if (item.r) {
      rating = '<div class="product-card__rating fu-wlp__rating" aria-label="' + esc(item.r) + ' out of 5 stars">' +
        '<span class="product-card__rating-star">&#9733;</span> <span class="product-card__rating-score">' + esc(item.r) + '</span>' +
        (item.n ? '<span class="product-card__rating-count">(' + esc(item.n) + ')</span>' : '') + '</div>';
    }
    var price = onSale
      ? '<div class="price price--on-sale flex flex-wrap gap-2"><span class="sr-only">Sale price</span><span class="price__regular whitespace-nowrap">' + money(v.price) + '</span><span class="sr-only">Regular price</span> <span class="price__sale inline-flex items-center h-auto relative line-through opacity-60">' + money(v.compare_at_price) + '</span></div>'
      : '<div class="price flex flex-wrap gap-2"><span class="price__regular whitespace-nowrap">' + money(v.price) + '</span></div>';

    card.querySelector('.fu-wlp__body').innerHTML =
      '<div class="fu-wlp__details"><div class="fu-wlp__info">' +
      '<a class="product-card__title reversed-link text-base-xl font-medium leading-tight" href="' + esc(url) + '">' + esc(p.title) +
      (colour ? ' <span class="product-card__variant-colour">' + esc(colour) + '</span>' : '') + '</a>' + rating +
      '</div>' + price + '</div>';
    card.classList.remove('is-loading');
    if (soldOut) card.classList.add('is-soldout');
    this.data[keyOf(item)] = { p: p, soldOut: soldOut };
    qsSetup(card, item, p, soldOut);
    this.updateAll();
  };

  /* ---------- boot ---------- */
  function init() {
    decorateCards(document);
    setupPdp();
    var page = document.querySelector('[data-fu-wl-page]');
    if (page && !page.__fuWl) { page.__fuWl = true; new WishlistPage(page); }
    syncAll();
    observe();
    /* Remember the size the shopper last added with any Quick Add, to pre-select it in Pick your sizes */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.fu-qa-size') : null;
      if (!b || b.disabled || b.closest('.fu-wls') || b.classList.contains('is-busy') || b.classList.contains('is-done') || b.classList.contains('is-one')) return;
      rememberSize(b.textContent);
    }, true);
    window.addEventListener('storage', function (e) {
      if (e.key === KEY || e.key === null) { cache = null; emit(); }
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { cache = null; emit(); }
    });
  }

  window.FuWishlist = {
    key: KEY,
    items: function () { return read().slice(); },
    count: function () { return read().length; },
    has: has, add: add, remove: remove, toggle: toggle,
    clear: function () { write([]); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
